import React, { useEffect, useState } from "react";
import {
  selectSecondeColor,
  selectFutureColor,
  changeSecondeColor,
  changeFutureColor,
} from "../../features/counter/counterSlice";
import { useDispatch, useSelector } from "react-redux";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import ColorChange from "../ColorChange/ColorChange";
import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import type { User } from "firebase/auth";

const Header = () => {
  // eslint-disable-next-line no-self-compare
  const [user, setUser] = useState<User | null>(null);
  // const [color, setColor] = useState("#ff0000");
  // const [futureColor, setFutureColor] = useState();
  const secondeColor = useSelector(selectSecondeColor);
  const futureColor = useSelector(selectFutureColor);
  const dispatch = useDispatch();
  // const handleChange = (event) => {
  //   setColor(event.target.value);
  // };
  // Définition de la fonction pour générer une couleur RVB aléatoire
  const randomColor = () => {
    const red = Math.max(Math.floor(Math.random() * 256), 70);
    const green = Math.max(Math.floor(Math.random() * 256), 70);
    const blue = Math.max(Math.floor(Math.random() * 256), 70);
    // dispatch(changeFutureColor(`rgb(${red}, ${green}, ${blue})`))
    // setFutureColor(`rgb(${red}, ${green}, ${blue})`)
    return `${red}, ${green}, ${blue}`;
  };
  function setSecondeColor() {
    // console.log(futureColor);
    // console.log(futureColor)

    dispatch(changeSecondeColor(futureColor));
    dispatch(changeFutureColor(randomColor()));
  }

  useEffect(() => {
    const myElement = document.getElementById("root");
    myElement?.style.setProperty("--secondary-color", `${secondeColor}`);
    // setFutureColor(randomColor)
    // dispatch(changeFutureColor(randomColor()))
  }, []);

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, setUser);
  return unsubscribe;
}, []);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };
  // console.log(secondeColor)
  return (
    <header>
      <nav className="header-nav">
        {/* <div className="svgColor" > */}

        <Link to="/" className="App-logo" title="Home">
          <Logo />
        </Link>
        {/* </div> */}
        {/* <div className="color">
          <button
            style={{ background: `${secondeColor}` }}
            onClick={() => dispatch(futureColor(randomColor()))}
          >
            Add Amount
          </button>
        </div> */}

        <div className="main-menu_nav">
          <ul className="ul_header">
            <li className="lifeLine">
              <Link to="/lifeline" title="lifeline">
                <svg width="24" height="24" viewBox="0 0 512 512" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    transform="scale(64)"
                    fill="#8d8d8d"
                  />
                  <circle fill="#8d8d8d" cx="254" cy="254" r="254" />

                  <g>
                    <rect
                      x="202.8"
                      y="112"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                    <rect
                      x="202.8"
                      y="166.4"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                    <rect
                      x="202.8"
                      y="220.4"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                    <rect
                      x="202.8"
                      y="274.8"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                    <rect
                      x="202.8"
                      y="328.8"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                    <rect
                      x="202.8"
                      y="383.2"
                      fill="#000000"
                      width="102.8"
                      height="12.8"
                    />
                  </g>
                  <g>
                    <path
                      fill="#000000"
                      d="M191.6,437.6L191.6,437.6c-6,0-11.2-4.8-11.2-11.2V81.6c0-6,4.8-11.2,11.2-11.2l0,0
		c6,0,11.2,4.8,11.2,11.2v344.8C202.8,432.4,197.6,437.6,191.6,437.6z"
                    />
                    <path
                      fill="#000000"
                      d="M316.4,437.6L316.4,437.6c-6,0-11.2-4.8-11.2-11.2V81.6c0-6,4.8-11.2,11.2-11.2l0,0
		c6,0,11.2,4.8,11.2,11.2v344.8C327.6,432.4,322.4,437.6,316.4,437.6z"
                    />
                  </g>
                </svg>
                LifeLine
              </Link>
            </li>

            <li className="linkedIn">
              <a
                aria-label="linkedIn"
                data-inlinesvg=".inlineSvgFile-6"
                href="https://www.linkedin.com/in/tessard/"
                title="LinkedIn"
              >
                <svg width="24" height="24" viewBox="0 0 1024 1024" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M256 7.025C118.494 7.025 7.025 118.494 7.025 256S118.494 504.975 256 504.975 504.976 393.506 504.976 256C504.975 118.494 393.504 7.025 256 7.025zm-66.427 369.343h-54.665V199.761h54.665v176.607zM161.98 176.633c-17.853 0-32.326-14.591-32.326-32.587 0-17.998 14.475-32.588 32.326-32.588s32.324 14.59 32.324 32.588c.001 17.997-14.472 32.587-32.324 32.587zm232.45 199.735h-54.4v-92.704c0-25.426-9.658-39.619-29.763-39.619-21.881 0-33.312 14.782-33.312 39.619v92.704h-52.43V199.761h52.43v23.786s15.771-29.173 53.219-29.173c37.449 0 64.257 22.866 64.257 70.169l-.001 111.825z"
                    transform="scale(2)"
                    fill="#8d8d8d"
                  />
                </svg>
                Linkedin
              </a>
            </li>
            <li className="github">
              <a
                aria-label="github"
                data-inlinesvg=".inlineSvgFile-6"
                href="https://github.com/MrTESSARD/"
                title="Github"
              >
                <svg width="24" height="24" viewBox="0 0 1024 1024" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.53 5.47 15.59C5.87 15.66 6.02 15.42 6.02 15.21C6.02 15.02 6.01 14.39 6.01 13.72C4 14.09 3.48 13.23 3.32 12.78C3.23 12.55 2.84 11.84 2.5 11.65C2.22 11.5 1.82 11.13 2.49 11.12C3.12 11.11 3.57 11.7 3.72 11.94C4.44 13.15 5.59 12.81 6.05 12.6C6.12 12.08 6.33 11.73 6.56 11.53C4.78 11.33 2.92 10.64 2.92 7.58C2.92 6.71 3.23 5.99 3.74 5.43C3.66 5.23 3.38 4.41 3.82 3.31C3.82 3.31 4.49 3.1 6.02 4.13C6.66 3.95 7.34 3.86 8.02 3.86C8.7 3.86 9.38 3.95 10.02 4.13C11.55 3.09 12.22 3.31 12.22 3.31C12.66 4.41 12.38 5.23 12.3 5.43C12.81 5.99 13.12 6.7 13.12 7.58C13.12 10.65 11.25 11.33 9.47 11.53C9.76 11.78 10.01 12.26 10.01 13.01C10.01 14.08 10 14.94 10 15.21C10 15.42 10.15 15.67 10.55 15.59C13.71 14.53 16 11.53 16 8C16 3.58 12.42 0 8 0Z"
                    transform="scale(64)"
                    fill="#8d8d8d"
                  />
                </svg>
                GitHub
              </a>
            </li>
            <li className="cv">
              <Link to="/cv" title="cv">
                <svg
                  width="24"
                  height="24"
                  viewBox="-100 0 1024 1024"
                  fill="none"
                  transform="scale(1)"
                >
                  <path
                    fill="#8d8d8d"
                    d="m279.9 388.4c-0.7 0-1.5 0-2.2-0.1-0.7 0-1.5-0.1-2.2-0.2s-1.5-0.2-2.2-0.3-1.5-0.2-2.2-0.4c-0.7-0.1-1.4-0.3-2.2-0.5l-2.1-0.6c-0.7-0.2-1.4-0.4-2.1-0.7-0.7-0.2-1.4-0.5-2.1-0.8s-1.3-0.6-2-0.9-1.3-0.6-2-1c-0.6-0.3-1.3-0.7-1.9-1.1s-1.3-0.8-1.9-1.2-1.2-0.8-1.8-1.3c-0.6-0.4-1.2-0.9-1.8-1.4s-1.1-0.9-1.7-1.4c-0.5-0.5-1.1-1-1.6-1.5s-1-1.1-1.5-1.6-1-1.1-1.4-1.7c-0.5-0.6-0.9-1.2-1.4-1.7-0.4-0.6-0.9-1.2-1.3-1.8s-0.8-1.2-1.2-1.9c-0.4-0.6-0.7-1.3-1.1-1.9-0.3-0.6-0.7-1.3-1-2s-0.6-1.3-0.9-2-0.5-1.4-0.8-2c-0.2-0.7-0.5-1.4-0.7-2.1l-0.6-2.1c-0.2-0.7-0.3-1.4-0.5-2.2-0.1-0.7-0.3-1.4-0.4-2.2-0.1-0.7-0.2-1.5-0.3-2.2s-0.1-1.5-0.2-2.2c0-0.7-0.1-1.5-0.1-2.2s0-1.5 0.1-2.2c0-0.7 0.1-1.5 0.2-2.2s0.2-1.5 0.3-2.2 0.2-1.4 0.4-2.2c0.2-0.7 0.3-1.4 0.5-2.1l0.6-2.1c0.2-0.7 0.5-1.4 0.7-2.1s0.5-1.4 0.8-2.1 0.6-1.4 0.9-2c0.3-0.7 0.7-1.3 1-2 0.3-0.6 0.7-1.3 1.1-1.9s0.8-1.3 1.2-1.9 0.8-1.2 1.3-1.8c0.4-0.6 0.9-1.2 1.4-1.7 0.5-0.6 1-1.1 1.4-1.7 0.5-0.5 1-1.1 1.5-1.6s1.1-1 1.6-1.5 1.1-1 1.7-1.4c0.6-0.5 1.2-0.9 1.8-1.4 0.6-0.4 1.2-0.9 1.8-1.3s1.2-0.8 1.9-1.2c0.6-0.4 1.3-0.7 1.9-1.1 0.6-0.3 1.3-0.7 2-1s1.3-0.6 2-0.9 1.4-0.5 2.1-0.8c0.7-0.2 1.4-0.5 2.1-0.7l2.1-0.6c0.7-0.2 1.4-0.3 2.2-0.5 0.7-0.1 1.5-0.3 2.2-0.4s1.5-0.2 2.2-0.3 1.5-0.1 2.2-0.2c1.5-0.1 3-0.1 4.4 0 0.7 0 1.5 0.1 2.2 0.2s1.5 0.2 2.2 0.3 1.5 0.2 2.2 0.4c0.7 0.1 1.4 0.3 2.2 0.5l2.1 0.6c0.7 0.2 1.4 0.5 2.1 0.7s1.4 0.5 2 0.8c0.7 0.3 1.4 0.6 2 0.9 0.7 0.3 1.3 0.6 2 1 0.6 0.3 1.3 0.7 1.9 1.1s1.2 0.8 1.9 1.2c0.6 0.4 1.2 0.8 1.8 1.3 0.6 0.4 1.2 0.9 1.8 1.4s1.1 1 1.7 1.4c0.5 0.5 1.1 1 1.6 1.5s1 1.1 1.5 1.6 1 1.1 1.5 1.7 0.9 1.1 1.4 1.7c0.4 0.6 0.9 1.2 1.3 1.8s0.8 1.2 1.2 1.9c0.4 0.6 0.7 1.3 1.1 1.9 0.3 0.6 0.7 1.3 1 2s0.6 1.3 0.9 2 0.5 1.4 0.8 2.1c0.2 0.7 0.5 1.4 0.7 2.1l0.6 2.1c0.2 0.7 0.3 1.4 0.5 2.1 0.1 0.7 0.3 1.5 0.4 2.2s0.2 1.5 0.3 2.2 0.1 1.5 0.2 2.2c0 0.7 0.1 1.5 0.1 2.2s0 1.5-0.1 2.2c0 0.7-0.1 1.5-0.2 2.2s-0.2 1.5-0.3 2.2-0.2 1.5-0.4 2.2c-0.1 0.7-0.3 1.4-0.5 2.2l-0.6 2.1c-0.2 0.7-0.4 1.4-0.7 2.1-0.2 0.7-0.5 1.4-0.8 2-0.3 0.7-0.6 1.4-0.9 2-0.3 0.7-0.6 1.3-1 2-0.3 0.7-0.7 1.3-1.1 1.9s-0.8 1.3-1.2 1.9-0.8 1.2-1.3 1.8c-0.4 0.6-0.9 1.2-1.4 1.7-0.5 0.6-1 1.1-1.5 1.7s-1 1.1-1.5 1.6-1.1 1-1.6 1.5-1.1 1-1.7 1.4c-0.6 0.5-1.2 0.9-1.8 1.4-0.6 0.4-1.2 0.9-1.8 1.3s-1.2 0.8-1.9 1.2c-0.6 0.4-1.3 0.7-1.9 1.1-0.7 0.3-1.3 0.7-2 1s-1.3 0.6-2 0.9-1.4 0.5-2 0.8c-0.7 0.2-1.4 0.5-2.1 0.7l-2.1 0.6c-0.7 0.2-1.4 0.3-2.2 0.5-0.7 0.1-1.5 0.3-2.2 0.4s-1.5 0.2-2.2 0.3-1.5 0.1-2.2 0.2-1.5 0.1-2.2 0.1zm-48.3 187.6h329.3v40h-329.3z"
                  />
                  <circle cx="280.1" cy="343.6" r="45.2" />
                  <path
                    fill="#8d8d8d"
                    d="m231.6 677.6h329.3v40h-329.3zm0-203.3h329.3v40h-329.3z"
                  />
                  <path
                    fill="#8d8d8d"
                    d="m400 0c-276.1 0-500 223.9-500 500s223.9 500 500 500 500-223.9 500-500-223.9-500-500-500zm230.8 794.5c0 11-9 20-20 20h-420.5c-11 0-20-9-20-20v-587.3c0-11 9-20 20-20l239.2 0.2v166.3c0 16.8 13.8 30.6 30.6 30.6h171.3zm0.6-456.5h-155.6v-150.5l155.5 150.1v0.4z"
                  />
                </svg>
                CV
              </Link>
            </li>
            <li className="contact">
              <Link to="/contact" title="contact">
                <svg width="24" height="24" viewBox="0 0 512 512" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    transform="scale(64)"
                    fill="#8d8d8d"
                  />
                  <circle fill="#8d8d8d" cx="254" cy="254" r="254" />
                  <g transform="translate(80, 100) scale(5)">
                    <path
                      fill="#000000"
                      stroke="#000000"
                      strokeWidth="3"
                      d="M62.9891,2.5618c-0.0765-0.5779-0.6611-0.9805-1.2299-0.8401L7.4043,15.2065c-0.3535,0.0879-0.6318,0.3608-0.7256,0.7129     s0.0112,0.7275,0.2744,0.9795l13.9343,13.3583l-2.7649,17.1495c-0.1079,0.6712,0.4969,1.2576,1.1582,1.1445l18.0805-3.1324     l17.1832,9.6988c0.1523,0.0859,0.3218,0.1289,0.4917,0.1289c0.1523,0,0.3047-0.0347,0.4453-0.1045     c0.2969-0.1475,0.5015-0.4331,0.5459-0.7617l6.9639-51.5542C63.0031,2.7372,63.0007,2.6487,62.9891,2.5618z M9.647,16.7109     L56.8914,4.9902L22.2545,28.7978L9.647,16.7109z M36.9146,43.4663l-16.5942,2.875l2.4995-15.5054L58.8633,6.0615L36.9146,43.4663     z M54.2427,52.6504l-15.3231-8.6492l21.4231-36.509L54.2427,52.6504z"
                    />

                    <path
                      fill="#000000"
                      stroke="#000000"
                      strokeWidth="3"
                      d="M14.4438,51.6099l-4.6948,5.209c-0.3701,0.4102-0.3369,1.0425,0.0732,1.4121c0.1909,0.1724,0.4307,0.2573,0.6689,0.2573     c0.2734,0,0.5459-0.1113,0.7432-0.3306l4.6948-5.209c0.3701-0.4102,0.3369-1.0425-0.0732-1.4121     C15.4463,51.1675,14.8135,51.2002,14.4438,51.6099z"
                    />

                    <path
                      fill="#000000"
                      stroke="#000000"
                      strokeWidth="3"
                      d="M5.9478,29.0562l-4.6909,5.2085c-0.3696,0.4106-0.3364,1.043,0.0742,1.4126c0.1909,0.1719,0.4302,0.2568,0.6685,0.2568     c0.2739,0,0.5459-0.1113,0.7437-0.3311l4.6909-5.2085c0.3696-0.4106,0.3364-1.043-0.0742-1.4126     C6.9487,28.6128,6.3179,28.6455,5.9478,29.0562z"
                    />

                    <path
                      fill="#000000"
                      stroke="#000000"
                      strokeWidth="3"
                      d="M40.8164,55.4331l-4.6909,5.2051c-0.3701,0.4102-0.3369,1.0425,0.0732,1.4121c0.1909,0.1724,0.4307,0.2573,0.6689,0.2573     c0.2734,0,0.5459-0.1113,0.7432-0.3306l4.6909-5.2051c0.3701-0.4102,0.3369-1.0425-0.0732-1.4121     C41.8188,54.9907,41.186,55.0234,40.8164,55.4331z"
                    />
                  </g>
                </svg>
                Contact
              </Link>
            </li>
            {user && (
              <li className="contact">
                <Button color="inherit" onClick={handleLogout}>
      Déconnexion
    </Button>
              </li>
            )}
          </ul>
        </div>
        <div className="svgColor" onClick={() => setSecondeColor()}>
          {/* <Goute /> */}
          <ColorChange />
        </div>
      </nav>
    </header>
  );
};
export default Header;
